import React from 'react';
import { Link } from 'react-router-dom';

const Linker = ({ name, path, target, download, children }) => {
  return (
    <>
      <Link className={name} to={path} download={download} target={target}>
        {children}
      </Link>
    </>
  )
}

export default Linker;